export const RESOURCE_PREVIEW_DIALOG_ID = 'resource-preview';
